module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "books-by-head"
  }, [_c('em', [_vm._v("Recent Titles by Marcia Talley")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_c('em', [_vm._v("The Hannah Ives Mysteries Series")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("SING IT TO HER BONES")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("UNBREATHED MEMORIES")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("OCCASION OF REVENGE")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("IN DEATH’S SHADOW")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("THIS ENEMY TOWN")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("THROUGH THE DARKNESS")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("DEAD MAN DANCING *")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("WITHOUT A GRAVE *")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("ALL THINGS UNDYING *")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("A QUIET DEATH *")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("THE LAST REFUGE *")]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_c('em', [_vm._v("* available from Severn House")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c285cf60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/alsoby.vue
// module id = 63
// module chunks = 0